/* eslint-disable */
import tmsApi from '../api/tmsApi';
import helper from './helper';

const { createInputParam } = helper;

export default {
  namespaced: true,
  state: {
    dataState: {
      vehicle: 'LOADING',
    },
    vehicle_groups: [],
    detailData: null,
    detailDataId: null,
    dataLoaded: false,
    useSkip: true,
    count_info: {
      all: 0,
    },
    query: {
      search: '',
      company_id: null,
      page: {
        number: 1,
        lastData: null,
        count: 10,
      },
      skip: {
        by: 'ID',
      },
      sort: {
        by: 'ID',
        direction: 'ASC',
      },
    },
    errors: {
      actions: [],
    },
  },
  mutations: {
    CLEAR_DATA(state) {
      state.vehicle_groups.splice(0);
    },
    ADD_DATA_ON_LIST(state, data) {
      state.vehicle_groups.push(data);
    },
    REPLACE_DATA(state, vehicle_groups) {
      state.vehicle_groups.splice(0, state.vehicle_groups.length, ...vehicle_groups);
    },
    CLEAR_QUERY({ query }) {
      query.search = '';
      query.company_id = null;
      query.page.number = 1;
      query.page.count = 10;
      query.sort.by = 'CREATED_AT';
      query.sort.direction = 'ASC';
    },
    SET_COMPANY_ID(state, id) {
      state.query.page.number = 1;
      state.query.page.count = 10;
      state.query.company_id = id;
    },
    SET_QUERY_SEARCH(state, search) {
      state.query.page.number = 1;
      state.query.page.count = 10;
      state.query.search = search;
    },
    SET_QUERY_PAGE(state, number) {
      state.query.page.number = number;
    },
    SET_QUERY_COUNT(state, count) {
      state.query.page.count = count;
    },
    SET_QUERY_SORT(state, sort) {
      const [by, direction] = sort.split('.');
      state.query.sort.direction = direction;
      state.query.sort.by = by;
    },
    SET_COUNT_INFO(state, info) {
      state.count_info.all = 0;
      info.forEach((c) => {
        state.count_info.all += c.count;
      }, this);
    },
    SET_DETAIL_ID(state, id) {
      state.detailDataId = id;
    },
    SET_DETAIL_DATA(state, data) {
      state.detailData = data;
    },
    SET_USE_SKIP(state, useSkip) {
      state.useSkip = useSkip;
    },
    DELETE_DETAIL_DATA(state, id) {
      const index = state.vehicle_groups.findIndex(vehicle => vehicle.id === id);
      state.vehicle_groups.splice(index, 1);
    },
    ADD_ERROR(state, action) {
      state.errors.actions.push(action);
    },
    REMOVE_ERROR(state, error) {
      const index = state.errors.actions.findIndex(err => err === error);
      state.errors.actions.splice(index, 1);
    },
    SET_DATA_LOADED(state) {
      state.dataLoaded = true;
    },
    SET_DATA_NOT_LOADED(state) {
      state.dataLoaded = false;
    },
    SET_DATA_VEHICLE({ dataState }, state) {
      dataState.vehicle = state;
    },
    SET_SKIP_BY(state, by) {
      state.query.skip.by = by;
    },
    SET_QUERY_LAST_DATA({ query }, data) {
      query.page.lastData = data;
    },
  },
  getters: {
    vehicle_groups(state) {
      return state.vehicle_groups;
    },
    companies(state) {
      return state.vehicle_groups;
    },
    count_all(state) {
      return state.count_info.all;
    },
    query_count(state) {
      return state.query.page.count;
    },
    query_page(state) {
      return state.query.page.number;
    },
    get_detail_data(state) {
      return state.detailData || {};
    },
    dataLoaded(state) {
      return state.dataLoaded;
    },
    loadVehicle(state) {
      return state.dataState.vehicle;
    },
  },
  actions: {
    LOAD_DATA({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const { lastData, count } = state.query.page;
      const { by, direction } = state.query.sort;
      const limit = count;
      const companyId = createInputParam(state.query, 'company_id', false);
      let searchQuery = '';
      if (typeof state.query.search === 'string' && state.query.search.trim().length) {
        const q = state.query.search.trim();
        searchQuery = `query: "${q}"`;
      }
      let after = '';
      let before = '';
      let skip = '';
      if (direction === 'ASC') {
        after = `after: "${lastData}"`;
      } else {
        before = `before: "${lastData}"`;
      }
      if (lastData !== null && state.useSkip) {
        skip = `
          skip: {
            by: ID
            ${after}
            ${before}
          },
        `;
      }
      const query = `
        {
          vehicle_groups(
            limit: ${limit},
            ${searchQuery},
            ${skip},
            sort: {
              by: ${by},
              direction: ${direction}
            },
            ${companyId}
          ) {
            id
            description
            company {
              id
              name
            }
            name
            created_at
          }
        }
      `;
      // commit('CLEAR_DATA');
      commit('SET_DATA_NOT_LOADED');
      commit('SET_DATA_VEHICLE', 'LOADING');
      return api(query, 'vehicle_groups').then(({ data }) => {
        const { vehicle_groups } = data;
        commit('REPLACE_DATA', vehicle_groups);
        commit('SET_DATA_LOADED');
        commit('SET_DATA_VEHICLE', 'LOADED');
      }).catch(() => {
        commit('SET_DATA_VEHICLE', 'ERROR');
      });
    },
    LOAD_DETAIL_DATA({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const query = `
        {
          vehicle_group(id: ${state.detailDataId}) {
            id
            name
            description
            company {
              id
              name
              type
            }
            members{
              id
              reg_no
            }
            created_at
          }
        }
      `;
      commit('SET_DATA_NOT_LOADED');
      return api(query, 'vehicle_group').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.vehicle_group);
        return data.vehicle_group;
      }).then(() => {
        setTimeout(() => commit('SET_DATA_LOADED'), 1e3);
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_DETAIL_DATA');
      });
    },
    LOAD_INFO({ state, commit, rootState }) {
      const api = tmsApi.buildRetry(rootState.token);
      const companyId = createInputParam(state.query, 'company_id', false);
      const query = `
        {
          vehicle_group_info(
            query: "${state.query.search}"
            ${companyId}
          ) {
              count
          }
        }
      `;
      // commit('CLEAR_DATA');
      return api(query, 'vehicle_group_info').then(({ data }) => {
        const { vehicle_group_info } = data;
        commit('SET_COUNT_INFO', vehicle_group_info);
      }).catch(() => {
        commit('ADD_ERROR', 'LOAD_INFO');
      });
    },
    UPDATE_DATA({ state, commit, rootState }, payloads) {
      const { detailDataId } = state;
      const { token } = rootState;
      const api = tmsApi.build(token);

      const name = createInputParam(payloads, 'name');
      const description = createInputParam(payloads, 'description');


      const mutation = `mutation {
        vehicle_group: update_vehicle_group(id: ${detailDataId}, input: {
          ${name}
          ${description}
        }) {
          id
          name
          description
          updated_at
        }
      }`;

      return api(mutation, 'update_vehicle_group').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.vehicle_group);
      }).catch(() => {
        commit('ADD_ERROR', 'UPDATE_DATA');
      });
    },
    CREATE_DATA({ commit, rootState }, payloads) {
      const { token } = rootState;
      const api = tmsApi.build(token);

      const name = createInputParam(payloads, 'name');
      const description = createInputParam(payloads, 'description');
      const comp = payloads.company;
      const companyId = comp.id;

      const mutation = `mutation {
        vehicle_group: create_vehicle_group(input: {
          ${name}
          company_id: ${companyId}
          ${description}
        }) {
          id
          name
          company {
            id
            name
            type
          }
          description
          created_at
        }
      }`;

      return api(mutation, 'create_vehicle_group').then(({ data }) => {
        commit('SET_DETAIL_DATA', data.vehicle_group);
        return data.vehicle_group;
      }).catch(() => {
        commit('ADD_ERROR', 'CREATE_DATA');
      });
    },
    DELETE_DATA({ state, commit, rootState }, vehicleId) {
      const id = !vehicleId ? state.detailDataId : vehicleId;
      const { token } = rootState;
      const api = tmsApi.build(token);

      const mutation = `mutation {
        deleted: delete_vehicle_group(id: ${id})
      }`;

      return api(mutation, 'delete_vehicle_group').then(({ data }) => {
        const deleteOk = data.deleted;
        if (deleteOk) commit('DELETE_DETAIL_DATA', id);
        return deleteOk;
      }).catch(() => {
        commit('ADD_ERROR', 'DELETE_DATA');
      });
    },
    MOVE_ASSIGN_VEHICLE_DATA({ state, commit, rootState }, payloads) {
      const id = state.detailDataId;
      const { token } = rootState;
      const api = tmsApi.build(token);
      const { vehicle_ids } = payloads;
      const mutation = `mutation {
        assign_multiple_vehicle_group(
          group_id: ${id},
          vehicle_ids: [${vehicle_ids}]
        )
      }`;
      return api(mutation, 'assign_multiple_vehicle_group').then(({ data }) => {
        return data.assign_multiple_vehicle_group;
      }).catch(() => {
        commit('ADD_ERROR', 'MOVE_ASSIGN_VEHICLE_DATA');
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/vehicle_group.js